import { axiosRequest } from 'constants/defaultValues';
import { getCurrentToken } from 'helpers/Utils';

let cachedPreferences = null;
let loadPromise = null;

export const getCachedPreferences = () => cachedPreferences;

export const clearUserPreferencesCache = () => {
  cachedPreferences = null;
  loadPromise = null;
};

export const patchCachedPreference = (key, value) => {
  cachedPreferences = {
    ...(cachedPreferences || {}),
    [key]: value
  };
};

export const loadUserPreferences = ({ force = false } = {}) => {
  if (!force && cachedPreferences) {
    return Promise.resolve(cachedPreferences);
  }
  if (!force && loadPromise) {
    return loadPromise;
  }

  loadPromise = axiosRequest('preferences', {
    method: 'GET',
    headers: { Authorization: `Bearer ${getCurrentToken()}` }
  })
    .then((response) => {
      cachedPreferences =
        response.success && response.data && typeof response.data === 'object'
          ? response.data
          : {};
      return cachedPreferences;
    })
    .catch(() => {
      cachedPreferences = cachedPreferences || {};
      return cachedPreferences;
    })
    .finally(() => {
      loadPromise = null;
    });

  return loadPromise;
};
